import { type DataForParent, emitMessageToChild, messagesForChild } from '@b2ag/micro-front-tools'
import { messagesForParent } from '@b2ag/micro-front-tools'

import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { getStore } from '~/store'
import { useUserSegments } from '@b2ag/segments'

async function callbackReorderSucceeded(cart) {
  const store = getStore()

  await store.dispatch('cart/setCart', cart)
  // Synchroniser les segments
  const { updateUserSegments } = useUserSegments()
  if (cart?.user?.segments) {
    updateUserSegments(cart.user.segments)
  }

  emitMessageToChild('cart', { message: messagesForChild.CART_UPDATED })
}

export function callbacksFromOrdersMicroFrontIframe(data: DataForParent) {
  switch (data.message) {
    case messagesForParent.RE_ORDER_ANALYTICS:
      useAnalyticService().trackEvent('click_reorder', {})
      break
    case messagesForParent.REORDER_SUCCEEDED:
      callbackReorderSucceeded(data.data)
      break
    default:
      break
  }
}
